import { environment } from '@environment';

export const paxApi = {
  pax_traveler_list: `${environment.api.travel_data_info}/traveler`,
  pax_create: `${environment.api.travel_data_info}/traveler`,
  pax_update: `${environment.api.travel_data_info}/traveler/{paxId}`,
  pax_delete: `${environment.api.travel_data_info}/traveler/{paxId}`,
  loyalty: {
    pax_loyalty_create: `${environment.api.travel_data_info}/traveler/loyalty`,
    pax_loyalty_update: `${environment.api.travel_data_info}/traveler/loyalty/{loyaltyId}`,
    pax_loyalty_delete: `${environment.api.travel_data_info}/traveler/loyalty/{loyaltyId}`,
    loyalty_token: `${environment.api.lifemiles_integration}/auth/token`,
    marriott_loyalty_number: `${environment.api.lifemiles_integration}/user-info/loyalty/application-user`,
    create_marriott_bonvoy_account: `${environment.api.lifemiles_integration}/marriott/enrrollment`
  },
  document: {
    pax_document_create: `${environment.api.travel_data_info}/traveler/document`,
    pax_document_update: `${environment.api.travel_data_info}/traveler/document/{documentId}`,
    pax_document_delete: `${environment.api.travel_data_info}/traveler/document/{documentId}`
  }
};
